import type { FC } from "react";
import React from "react";
import { Icons } from "@/components/NavIcon";
import type { IconName } from "../NavIcon";
import BetaBadge from "./BetaBadge";
import css from "./NavMenu.module.css";

type NavItemProps = {
  children: string;
  icon?: IconName;
  isBeta?: boolean;
};

const NavBtnContent: FC<NavItemProps> = ({ children, icon, isBeta }) => {
  const Icon = icon ? Icons[icon] : null;
  return (
    <>
      {Icon && (
        <span className={css.itemButtonIcon}>
          <Icon />
        </span>
      )}
      <span className={css.itemButtonText}>{children}</span>
      {isBeta && <BetaBadge />}
    </>
  );
};

export default NavBtnContent;
